import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormWizardPage, FormWizardPageElement, FormWizardTemplate } from 'src/app/models/form-wizard-template.model';
import * as _ from 'lodash';
import { NgForm } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-form-wizard',
  templateUrl: './form-wizard.component.html',
  styleUrls: ['./form-wizard.component.scss']
})
export class FormWizardComponent implements OnInit, OnDestroy {
  @Input() template: FormWizardTemplate | undefined;
  @Input() formValues: any | undefined;
  @Output() actionButtonClick = new EventEmitter<string>();

  @ViewChild('wizardForm') public wizardForm: NgForm | undefined;

  private currentPage: number;

  constructor(private domSanitizer: DomSanitizer) {
    this.currentPage = 0;
   }

  ngOnInit(): void {
    this.setDefaultValues();

    if (!_.isNil(this.formValues?.currentPage) && this.formValues?.currentPage !== '') {
      this.currentPage = this.formValues.currentPage;
    }
  }

  ngOnDestroy(): void {
    if (!_.isNil(this.formValues)) {
      this.formValues.currentPage = this.currentPage;
    }
  }

  public getLabel(): string {
    return !_.isNil(this.template) ? this.template.label : '';
  }

  public getDescription(): string {
    return !_.isNil(this.template) ? this.template.description : '';
  }

  public isStepperVisible(): boolean {
    return !_.isNil(this.template) && !_.isNil(this.template.pages) && this.template.pages.length > 1;
  }

  public isRightSectionVisible(): boolean {
    return !_.isNil(this.template) && !_.isNil(this.template.rightSectionHtml) && this.template.rightSectionHtml !== '';
  }

  public getRightSectionHtml(): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(this.template?.rightSectionHtml ?? '');
  }

  public getPages(): Array<FormWizardPage> {
    return !_.isNil(this.template) ? this.template.pages : [];
  }

  public getPageStatusIconClasses(pageIndex: number): string {
    let result = '';

    if (pageIndex < this.currentPage) {
      result = 'bi-check-circle-fill wizard-step'; 
    } else if (pageIndex === this.currentPage) {
      result = 'bi-circle-fill wizard-step';
    } else {
      result = 'bi-circle wizard-step-to-do';
    }

    return result;
  }

  public getPageStatusClasses(pageIndex:number): string {
    let result = '';

    if (pageIndex > this.currentPage) {
      result = 'wizard-step-to-do'; 
    } else {
      result = 'wizard-step';
    }

    return result;
  }

  public getPageLabel(): string {
    return !_.isNil(this.template) ? this.template.pages[this.currentPage].label : '';
  }

  public getPageElements(): Array<FormWizardPageElement> {
    return !_.isNil(this.template) ? this.template.pages[this.currentPage].elements : [];
  }

  public getPreviousButtonLabel(): string {
    return this.template?.pages[this.currentPage].previousButtonLabel ?? '';
  }

  public getNextButtonLabel(): string {
    return this.template?.pages[this.currentPage].nextButtonLabel ?? '';
  }

  public getCompleteButtonLabel(): string {
    return this.template?.pages[this.currentPage].completeButtonLabel ?? '';
  }

  public getCompleteButtonClasses(): string {
    return this.template?.pages[this.currentPage].completeButtonClasses ?? 'button-primany';
  }

  public isPreviousButtonVisible(): boolean {
    return this.getPreviousButtonLabel() !== '';
  }

  public isNextButtonVisible(): boolean {
    return this.getNextButtonLabel() !== '';
  }

  public isCompleteButtonVisible(): boolean {
    return this.getCompleteButtonLabel() !== '';
  }

  public isPreviousButtonDisabled(): boolean {
    return false;
  }

  public isNextButtonDisabled(): boolean {
    return false;
  }

  public isCompleteButtonDisabled(): boolean {
    return false;
  }

  public onPreviousButtonClick(): void {
    if (this.currentPage === 0) {
      this.actionButtonClick.emit('previous');
    } else {
      this.currentPage--;
    }
  }

  public onNextButtonClick(): void {
    if (this.wizardForm?.invalid) {
      this.wizardForm.control.markAllAsTouched();
    } else {
      this.currentPage++;
    }
  }

  public onCompleteButtonClick(): void {
    if (this.wizardForm?.invalid) {
      this.wizardForm.control.markAllAsTouched();
    } else {
      this.actionButtonClick.emit('complete');
    }
  }

  private setDefaultValues(): void {
    if (!_.isNil(this.formValues) && !_.isNil(this.template?.pages)) {
      this.template?.pages.forEach((page) => {
        if (!_.isNil(page.elements)) {
          page.elements.forEach((element) => {
            if (_.isNil(this.formValues[element.name]) && !_.isNil(element.defaultValue)) {
              switch (element.type) {
                default:
                  this.formValues[element.name] = element.defaultValue;
                  break;
              }
            }
          });
        }
      });
    }
  }
}
